import CPContainer from "@components/ui/CPContainer/CPContainer"
import { BackgroundImage, Flex, Overlay } from "@mantine/core"
import { useIsMobile } from "@utils/device.utils"
import { PropsWithChildren } from "react"

interface OffsetBackgroundProps extends PropsWithChildren {
	backgroundImage: string
	backgroundPosition: string
	backgroundSize?: string | number
	align?: "left" | "right" | "center"
	height?: string | number | object
	minHeight?: string | number | object
	childrenMaxWidth?: string | number | object
	backgroundColor?: string
	useGradient?: boolean
}

const OffsetBackground = ({
	backgroundImage,
	backgroundPosition = "center",
	backgroundSize = "cover",
	align = "left",
	children,
	height,
	minHeight,
	childrenMaxWidth,
	backgroundColor,
	useGradient = false
}: OffsetBackgroundProps) => {
	const isMobile = useIsMobile()

	const selectPositionChildren = (direction: string) => {
		switch (direction) {
			case "left":
				return "flex-start"
			case "center":
				return "center"
			default:
				return "flex-end"
		}
	}

	return (
		<BackgroundImage
			src={backgroundImage}
			mih={minHeight ?? { base: 550, sm: 600 }}
			style={{
				backgroundPosition: backgroundPosition,
				backgroundSize: backgroundSize,
				backgroundColor: backgroundColor
			}}
			h={height}
			pos="relative"
		>
			<CPContainer py={64} h="100%" mih="inherit">
				<Flex
					flex={1}
					h="100%"
					mih="inherit"
					align="center"
					justify={selectPositionChildren(align)}
				>
					{useGradient && (
						<Overlay
							gradient={"linear-gradient(to bottom, transparent, black)"}
							opacity={0.8}
						/>
					)}
					<Flex
						direction="column"
						gap={40}
						px="md"
						w={isMobile ? "100%" : undefined}
						maw={childrenMaxWidth ?? 760}
						style={{
							zIndex: 202
						}}
					>
						{children}
					</Flex>
				</Flex>
			</CPContainer>
		</BackgroundImage>
	)
}

export default OffsetBackground
